import React from "react";
import Button from "react-bootstrap/Button";
import { BsArrowRepeat } from "react-icons/bs";

export default function LoaderButton({
  isLoading,
  className = "",
  isDisabled,
  ...props
}) {
  return (
    <Button
      disabled={isLoading || isDisabled()}
      className={`LoaderButton ${className}`}
      {...props}
    >
      {isLoading && <BsArrowRepeat className="spinning" />}
      {props.children}
    </Button>
  );
}
